// extracted by mini-css-extract-plugin
module.exports = {"price":"styles_price__23MBV","white":"styles_white__tQvO8","blue":"styles_blue__2gJA0"};